import styled from "styled-components";
import { setFontVariant } from "@similarweb/styles";
import { colorsPalettes } from "@similarweb/styles";
import { FlexRow, FlexColumn } from "pro-features/styled components/StyledFlex/src/StyledFlex";

export const Header = styled(FlexRow)`
    position: relative;
    height: 64px;
    padding-bottom: 8px;
`;

export const TextContainer = styled(FlexColumn)`
    margin: auto 0;

    & > p {
        margin: auto 0;
    }
`;

export const IconContainer = styled.div`
    margin: auto 20px auto 16px;
`;

export const InfoWrapper = styled(FlexRow)`
    align-items: center;
    position: absolute;
    top: -5px;
    right: 20px;
    height: 100%;
`;

export const Title = styled.p`
    max-width: 400px;
    white-space: nowrap;
    text-overflow: ellipsis;
    overflow: hidden;
    ${setFontVariant("subtitle1", colorsPalettes.carbon[500])};
`;

export const Subtitle = styled.p`
    ${setFontVariant("body2", colorsPalettes.carbon[500])};
`;
